<template>
  <li class="relative col-span-2 row-span-2">
    <ClinicianLeftOverlay v-if="!userJitsiId" />

    <div class="group block h-full overflow-hidden relative" v-else>
      <StreamPlayerRemote
        :jitsiUserId="userJitsiId"
        :setVideoAudioRefs="setVideoAudioRefs"
        :showVideo="shouldShowModeratorVideo"
        :isAudioMuted="sessionStore.isPutOnHold"
      />

      <div
        class="flex justify-center items-center h-full w-full bg-vice-medium-teal z-20 rounded-xl"
        v-show="moderatorHasVideoAndSessionIsOngoing"
      >
        <VideoOff
          :name="remoteDisplayInfo?.['name']"
          :profile_photo_url="remoteDisplayInfo?.['avatar']"
        />
      </div>

      <SpeakingIndicator :audioLevel="remoteDisplayInfo?.audioLevel" />
      <UserLabel
        :localStats="remoteDisplayInfo?.['connectionQuality']"
        :isMutedMicrophone="!remoteDisplayInfo?.['audio'] || sessionStore.isPutOnHold"
        :displayName="remoteDisplayInfo?.['name'] + ' (Host)'"
      />
      <SessionPausedOverlay
        v-if="sessionStore.isPhasePaused"
        :currentPhase="sessionStore.currentPhaseData.title"
      />
    </div>
  </li>
</template>
<script>
import { computed } from 'vue';
import VideoOff from '@/Components/Session/Grid/VideoOff.vue';
import UserLabel from '@/Components/Session/Grid/UserLabel.vue';
import useSessionStore from '@/Stores/useSessionStore';
import StreamPlayerRemote from '@/Components/Session/Grid/StreamPlayerRemote.vue';
import SpeakingIndicator from '@/Components/Session/Grid/SpeakingIndicator';
import SessionPausedOverlay from '@/Components/Session/Overlays/SessionPausedOverlay';
import ClinicianLeftOverlay from '@/Components/Session/Overlays/ClinicianLeftOverlay.vue';

export default {
  props: {
    userJitsiId: {
      type: [Number, String],
    },
    remoteDisplayInfo: {
      type: Object,
    },
    setVideoAudioRefs: {
      type: Function,
      required: true,
    },
  },
  components: {
    VideoOff,
    UserLabel,
    SpeakingIndicator,
    StreamPlayerRemote,
    ClinicianLeftOverlay,
    SessionPausedOverlay,
  },
  setup(props) {
    const sessionStore = useSessionStore();
    const shouldShowModeratorVideo = computed(
      () => props.remoteDisplayInfo?.video && !sessionStore.isPutOnHold,
    );
    const moderatorHasVideoAndSessionIsOngoing = computed(
      () =>
        !props.remoteDisplayInfo?.video || sessionStore.isPutOnHold || sessionStore.isPhasePaused,
    );

    return { sessionStore, shouldShowModeratorVideo, moderatorHasVideoAndSessionIsOngoing };
  },
};
</script>
